import React, { useState, useEffect } from 'react';
import axios from "axios";
import * as XLSX from 'xlsx';
import BackendDrivenDataTable from '../../pages/cn/components/common/BackendDrivenDataTable';
import { Link } from 'react-router-dom';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { exportTableData, LoaderLoader, decryptData } from '../../pages/utils/CommonLibrary'
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import CalendarDatePicker from "../../pages/componenents/CalendarDatePicker"
import { fetchDataUploadHistory, addServiceRecommendationsFile, fetchDropdownList } from '../../services/hih/Service';
import DataUploadActionDropDown from './DataUploadActionDropDown';
import './hih.css';

const DataUploadHistory = () => {
    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';

    const [startDate, setStartDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment()
    );
    const [endDate, setEndDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
    );
    const [recordsList, setRecordsList] = useState([])
    const [isNewLoading, setIsNewLoading] = useState(false);

    const [searchQuery, setSearchQuery] = useState('');
    const [source, setSource] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [insightsDataPoints, setInsightsDataPoints] = useState({
        "totalRecordsCount": "0",
        "successRecordsCount": "0",
        "failedRecordsCount": "0",
        "totalMemberCount": "0",
        "onboardedMemberCount": "0",
        "notonboardedMemberCount": "0",
        "lightccmMemberCount": "0",
        "refillCount": "0",
        "labCount": "0"
    });
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("recordId");
    const [sortDirection, setSortDirection] = useState('desc');
    const [download, setDownload] = useState('N');
    const [showFileUploadModal, setShowFileUploadModal] = useState(false);
    const [showBulkUploadGuidelinesModal, setShowBulkUploadGuidelinesModal] = useState(false);
    
    const addFileObject = {
        file: null,
        fileName: ""
    }
    const [addFileFormData, setAddFileFormData] = useState(addFileObject);
    const [aiBupaRecommendationSourceList, setAIBupaRecommendationSourceList] = useState([]);
    const [aiBupaSelectedSource, setAIBupaSelectedSource] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchListRecords();
    }, [startDate, endDate, page, perPage, sortColumn, sortDirection, searchQuery, download]);


    const fetchListRecords = async () => {
        setIsNewLoading(true);
        try {
            await fetchDataUploadHistory(formatDate(startDate), formatDate(endDate), page, perPage, sortColumn, sortDirection).then((response) => {
                setRecordsList(response.data.data.logs);
                setTotalRows(response.data.data.totalRows);
                setInsightsDataPoints(response.data.data.insights);
            });
            setIsNewLoading(false);
        } catch (error) {
            setIsNewLoading(false);
        }
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleDateChange = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const getAIBupaRecommendationSourceList = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchDropdownList('aibuparecommendationsource', ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setAIBupaRecommendationSourceList(response.data.data.options);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const columns = [
        {
            name: (
                <span>Uploaded Date</span>
            ),
            selector: row => row.date,
            sortable: true,
        },
        {
            name: (
                <span>Uploaded Records</span>
            ),
            selector: row => row.totalRecordsCount,
            sortable: true,
        },
        {
            name: (
                <span>Successful Uploaded Records</span>
            ),
            selector: row => row.successRecordsCount,
            sortable: false,
        },
        {
            name: (
                <span>Failed Records Uploaded</span>
            ),
            selector: row => row.failedRecordsCount,
            sortable: false,
        },
        {
            name: (
                <span>Uploaded Members</span>
            ),
            selector: row => row.totalMemberCount,
            sortable: false,
        },
        {
            name: (
                <span>Uploaded By</span>
            ),
            selector: row => row.uploadedBy,
            sortable: false,
        },
        {
            name: (
                <span>Source</span>
            ),
            selector: row => row.source,
            sortable: false,
        },
        {
            name: 'Options',
            sortable: false,
            cell: row => (
                <>
                    <Link to={`/processed-data-insights/${row.id}`} className='btn btn-Edit mx-3'><i className="bi bi-eye"></i></Link>
                    |
                    <DataUploadActionDropDown originalFileLink={row.originalFileLink} successFileLink={row.successFileLink} failedFileLink={row.failedFileLink} />
                </>
            ),
        }
    ];

    const handleAddFileChange = (event) => {
        setError("");
        const file = event.target.files[0];
        if (!file) return;
        
        const fileName = file.name;
        const allowedExtensions = ['xlsx'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (file && allowedExtensions.includes(fileExtension)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const fileData = e.target.result;
                setAddFileFormData({
                    ...addFileFormData,
                    file: fileData,
                    fileName: fileName
                });
            }
            reader.readAsDataURL(file);
        } else {
            setAddFileFormData({
                ...addFileFormData,
                file: null,
                fileName: ''
            });
            event.target.value = ''
            setError("Invalid file type. Please select a valid file.");
        }
    };

    const handleAddFileSubmit = async () => {
        setError("");
        let error = "";
        if (addFileFormData.file === null) {
            error = "Please select the file";
        } else if (source == null || source == "") {
            error = "Please enter the source";
        }

        if (error === "") {
            await addServiceRecommendationsFile(addFileFormData.file, addFileFormData.fileName, source)
                .then((response) => {
                    if (response.data.code === 200) {
                        setMessage(response.data.data.message);
                        fetchListRecords();
                        setAddFileFormData(addFileObject);
                        document.getElementById('file').value = '';
                        setTimeout(() => {
                            setShowFileUploadModal(false);
                        }, [3000]);
                    } else {
                        setError(response.data.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        } else {
            setError(error);
        }
    }

    const openFileUploadModal = () => {
        setError("");
        setMessage("");
        setSource("");
        getAIBupaRecommendationSourceList();
        setShowFileUploadModal(true);
    };


    // const downloadTemplate = () => {
    //     // Define your template headers
    //     const headers = [
    //       'main_mbrshp_no', 'mbrshp_no', 'name', 'mbr_mobile_no', 'sex', 'age',
    //       'vip_code', 'ambassador_ind', 'id_card_no', 'net_type', 'cont_no',
    //       'cust_name', 'cont_term_date', 'serv_desc', 'supply_from', 'supply_to',
    //       'qty', 'serv_code', 'prov_name', 'prov_frequent_city', 'service_type',
    //       'chronic_conditions_of_mem', 'generated_date'
    //     ];
        
    //     // Create sample data row
    //     const sampleData = [
    //       'KSA123456', 'MEM123456', 'John Smith', '9665XXXXXXX', 'M', '45',
    //       'VIP001', 'N', 'ID12345', 'EMC', 'CONT001',
    //       'ACME Corp', new Date('2025-12-31'), 'Medication Refill', new Date('2025-05-01'), new Date('2025-05-31'),
    //       '30', 'MED123', 'Central Pharmacy', 'Riyadh', 'refill',
    //       'Diabetes,Hypertension', new Date()
    //     ];
        
    //     // Create a second example row for lab service
    //     const sampleData2 = [
    //       'KSA789012', 'MEM789012', 'Sarah Johnson', '9665XXXXXXX', 'F', '38',
    //       'VIP002', 'Y', 'ID67890', 'EMC', 'CONT002',
    //       'XYZ Corp', new Date('2026-06-30'), 'Blood Test', new Date('2025-05-15'), new Date('2025-05-20'),
    //       '1', 'LAB456', 'Central Laboratory', 'Jeddah', 'lab',
    //       'Cholesterol', new Date()
    //     ];
        
    //     // Create a new workbook
    //     const wb = XLSX.utils.book_new();
        
    //     // Create worksheet with headers and sample data
    //     const ws = XLSX.utils.aoa_to_sheet([
    //       headers,
    //       sampleData,
    //       sampleData2
    //     ]);
        
    //     // Define date columns (0-indexed)
    //     const dateColumns = [12, 14, 15, 22]; // cont_term_date, supply_from, supply_to, generated_date
        
    //     // Set column widths and formats
    //     const colWidths = headers.map((header, idx) => {
    //       // Set wider columns for certain fields
    //       if (header === 'name' || header === 'serv_desc' || header === 'chronic_conditions_of_mem') {
    //         return { wch: 30 };
    //       }
    //       // Set date format for date columns
    //       if (dateColumns.includes(idx)) {
    //         return { wch: 20, z: 'mm/dd/yyyy' };
    //       }
    //       return { wch: 20 };
    //     });
        
    //     ws['!cols'] = colWidths;
        
    //     // Apply date formats to cells
    //     dateColumns.forEach(col => {
    //       // Apply to first sample row
    //       let cellRef1 = XLSX.utils.encode_cell({ r: 1, c: col });
    //       if (ws[cellRef1] && ws[cellRef1].t === 'd') {
    //         ws[cellRef1].z = 'mm/dd/yyyy';
    //       }
          
    //       // Apply to second sample row
    //       let cellRef2 = XLSX.utils.encode_cell({ r: 2, c: col });
    //       if (ws[cellRef2] && ws[cellRef2].t === 'd') {
    //         ws[cellRef2].z = 'mm/dd/yyyy';
    //       }
    //     });
        
    //     // Add an instruction row with a different style
    //     const instructionWs = XLSX.utils.aoa_to_sheet([
    //       ['INSTRUCTIONS FOR FILLING THE TEMPLATE'],
    //       ['1. Do not delete or reorder columns'],
    //       ['2. Fill in all mandatory fields marked in the table above'],
    //       ['3. Date fields must be in MM/DD/YYYY format'],
    //       ['4. For sex field, use only "M" or "F"'],
    //       ['5. For service_type field, use only "refill" or "lab"'],
    //       ['6. For multiple chronic conditions, separate with commas'],
    //       ['7. Please see the sample data in the Template sheet for reference']
    //     ]);
        
    //     // Set column width for instruction sheet
    //     instructionWs['!cols'] = [{ wch: 80 }];
        
    //     // Add worksheets to workbook
    //     XLSX.utils.book_append_sheet(wb, instructionWs, 'Instructions');
    //     XLSX.utils.book_append_sheet(wb, ws, 'Template');
        
    //     // Generate actual XLSX file (binary)
    //     const excelBinary = XLSX.write(wb, { 
    //       bookType: 'xlsx', 
    //       type: 'binary',
    //       bookSST: false,
    //       compression: true
    //     });
        
    //     // Convert string to ArrayBuffer
    //     const buffer = new ArrayBuffer(excelBinary.length);
    //     const view = new Uint8Array(buffer);
    //     for (let i = 0; i < excelBinary.length; i++) {
    //       view[i] = excelBinary.charCodeAt(i) & 0xFF;
    //     }
        
    //     // Create Blob with the correct MIME type
    //     const blob = new Blob([buffer], { 
    //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    //     });
        
    //     // Create download link
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'HIH_Service_Recommendation_Template.xlsx');
        
    //     // Trigger download
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
        
    //     // Clean up
    //     window.URL.revokeObjectURL(url);
    //   };

const downloadTemplate = async () => {
    try {
      // URL of the template file
      const fileUrl = 'https://storage.googleapis.com/ksabupatest/2025/05/06/4s8ab/52djws7hq4.xlsx';
      
      // Fetch the file
      const response = await fetch(fileUrl);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch template: ${response.status} ${response.statusText}`);
      }
      
      // Get the file as a blob
      const blob = await response.blob();
      
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Set the custom filename for download
      link.setAttribute('download', 'HIH_Service_Recommendation_Template.xlsx');
      
      // Append to body, trigger click to download, then remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error downloading template:', error);
      // You might want to show a user-friendly error message here
      alert('Failed to download the template. Please try again later.');
    }
  };

    return (
        <>
            <section className='ReportsPrograms'>
                <div className="container-fluid px-0 mb-3 ">
                    <div className="row align-items-center pb-3 sticky-top-bar">
                        <div className="col-md ">
                            <h1 className="main-title">Data Upload History</h1>
                        </div>

                        <div className="col-md-3">
                            <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} />
                        </div>
                    </div>
                    <div className='reports-programs mb-3'>
                        <div className=" row align-items-center">
                            <div className="col-md-auto">
                                <img src="https://storage.googleapis.com/ksabupatest/2025/04/04/nu7hk/hlqlxags7e.jpg" alt="Invited Members icon" style={{ height: "140px" }} />
                            </div>
                            <div className="col-md">
                                <p className="mb-0">The Data Upload module allows administrators to upload and manage service recommendation data efficiently. It supports bulk data uploads Excel files, validates input fields, and ensures smooth integration with the service recommendation system.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-ProgramPerformance mb-3 p-2'>
                    <div className='row text-center px-2'>
                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.totalRecordsCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Uploaded Records
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Total count of records uploaded into the HIH system.</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.successRecordsCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Successful Uploaded Records
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Total count of records successfully uploaded into the HIH system.</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.failedRecordsCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Failed Records Uploaded
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Total count of records that failed during the upload process.</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row text-center px-2 mt-2'>
                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.totalMemberCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Uploaded Members
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Total number of unique members uploaded.</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.onboardedMemberCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Enrolled Members (CCM)
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Count of enrolled CCM members.</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.notonboardedMemberCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Not Onboarded Members
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Count of members that are not onboarded including CCM and light CCM members</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row text-center px-2 mt-2'>
                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.lightccmMemberCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Light CCM Members
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Count of Light CCM members uploaded</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.labCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Lab Recommendations
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Count of lab recommendations uploaded</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col px-1">
                            <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsDataPoints?.refillCount || '0'}</h1>
                                            <h5 className="card-text1">
                                                Refill Recommendations
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="custom-tooltip">Count of refill recommendations uploaded</Tooltip>}>
                                                        <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='reports-programs mb-3'>
                    <div className='row'>
                        <div className='col-12 text-end mb-3'>
                            <button 
                                type='button' 
                                className='btn btn-primary add-new-program-btn' 
                                onClick={openFileUploadModal}
                            >
                                Upload File
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive table-hih">
                                {
                                    isNewLoading ? <LoaderLoader /> :
                                        <BackendDrivenDataTable
                                            data={recordsList}
                                            loading={isNewLoading}
                                            totalRows={totalRows}
                                            page={page}
                                            perPage={perPage}
                                            sortColumn={sortColumn}
                                            sortDirection={sortDirection}
                                            filterText={searchQuery}
                                            columns={columns}
                                            fetchTableData={fetchListRecords}
                                            setPage={setPage}
                                            setSortColumn={setSortColumn}
                                            setSortDirection={setSortDirection}
                                            setPerPage={setPerPage}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* File Upload Modal */}
                <Modal 
                    show={showFileUploadModal} 
                    onHide={() => setShowFileUploadModal(false)} 
                    centered 
                    size="md" 
                    backdrop="static" 
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title as="h1" className="tw-text-xl tw-font-semibold">Upload Service Recommendations</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='tw-flex tw-flex-col tw-mb-4'>
                            <div className='tw-w-full'>
                                <div className="tw-bg-white tw-rounded-xl tw-p-2 tw-shadow-md tw-border-none">
                                    <div className="tw-flex tw-justify-between tw-items-center">
                                        <div>
                                            <Button 
                                                variant="link" 
                                                className="tw-no-underline tw-p-0 tw-text-[#03335B] tw-font-semibold hover:tw-drop-shadow-md" 
                                                onClick={() => setShowBulkUploadGuidelinesModal(true)}
                                            >
                                                View Upload Format Guidelines
                                            </Button>
                                        </div>
                                        <div>
                                            <Button variant="link" className="tw-no-underline tw-p-0 tw-text-[#03335B] tw-font-semibold hover:tw-drop-shadow-md" onClick={downloadTemplate}>
                                                Download Template
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='tw-flex tw-flex-col'>
                            <div className='tw-w-full'>
                                <div className="tw-mb-3">
                                    <label className="tw-block tw-mb-1 tw-font-medium">
                                        File <span className='tw-text-red-500'>*</span>
                                    </label>
                                    <input 
                                        type="file" 
                                        id="file" 
                                        className='form-control control-input-ui-addmember' 
                                        onChange={handleAddFileChange} 
                                        accept=".xlsx" 
                                    />
                                </div>
                                
                                <div className="tw-mb-3">
                                    <label className="tw-block tw-mb-1 tw-font-medium">
                                        Source <span className='tw-text-red-500'>*</span>
                                    </label>
                                    <select 
                                        className="form-select select-input-ui" 
                                        value={source} 
                                        onChange={(e) => setSource(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {aiBupaRecommendationSourceList.map((item, index) => (
                                            <option value={item.dropdownValue} key={index}>
                                                {item.dropdownLabel}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                {error && <div className="tw-bg-red-100 tw-text-red-700 tw-p-2 tw-rounded tw-mt-2">{error}</div>}
                                {message && <div className="tw-bg-green-100 tw-text-green-700 tw-p-2 tw-rounded tw-mt-2">{message}</div>}
                                
                                <div className="tw-flex tw-justify-center tw-mt-4">
                                    <Button 
                                        onClick={handleAddFileSubmit} 
                                        variant="primary" 
                                        className="btn save-btn"
                                    >
                                        Upload
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Bulk Upload Guidelines Modal */}
                <Modal 
                    show={showBulkUploadGuidelinesModal} 
                    onHide={() => setShowBulkUploadGuidelinesModal(false)} 
                    size="xl" 
                    centered
                    contentClassName="tw-border-0"
                >
                    <div className='tw-bg-gradient-to-r tw-from-sky-50 tw-to-blue-50 tw-rounded-3xl tw-overflow-hidden tw-shadow-lg'>
                        <Modal.Header className='tw-border-0 tw-bg-white tw-bg-opacity-70 tw-backdrop-blur-sm' closeButton>
                            <Modal.Title as="h1" className="tw-text-xl tw-font-semibold tw-text-[#03335B] tw-pl-2">
                                Guidelines for HIH Upload Service
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='tw-px-6 tw-py-5'>
                            <div className="tw-mb-6 tw-bg-white tw-bg-opacity-70 tw-p-4 tw-rounded-xl tw-shadow-sm">
                                <h4 className="tw-font-medium tw-text-gray-700 tw-mb-3">Key Requirements</h4>
                                <ol className="tw-list-decimal tw-pl-5 tw-text-gray-700">
                                    <li className="tw-mb-2 tw-leading-relaxed">
                                        <span className="tw-font-medium">Preserve Column Structure:</span> Do not delete any columns; each is vital for the migration process. Removing columns will lead to a upload failure.
                                    </li>
                                    <li className="tw-mb-2 tw-leading-relaxed">
                                        <span className="tw-font-medium">Maintain Column Order:</span> The sequence of columns should remain unchanged. Reordering columns will result in errors.
                                    </li>
                                </ol>
                            </div>

                            <h4 className="tw-font-medium tw-text-gray-700 tw-mb-3">Field Specifications</h4>
                            <div className="tw-overflow-x-auto tw-bg-white tw-rounded-xl tw-shadow-md">
                                <table className="tw-min-w-full">
                                    <thead>
                                        <tr className="tw-bg-[#03335B] tw-text-white">
                                            <th className="tw-px-4 tw-py-3 tw-text-left tw-font-medium">Columns Name</th>
                                            <th className="tw-px-4 tw-py-3 tw-text-left tw-font-medium">Data Type</th>
                                            <th className="tw-px-4 tw-py-3 tw-text-left tw-font-medium">Mandatory / Optional</th>
                                            <th className="tw-px-4 tw-py-3 tw-text-left tw-font-medium">Validation / Possible values</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">main_mbrshp_no</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">mbrshp_no</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">name</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">mbr_mobile_no</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">9 to 12 digit</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">sex</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">Possible value M / F</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">age</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">int</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">vip_code</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">ambassador_ind</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">id_card_no</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">net_type</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">cont_no</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">cust_name</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">cont_term_date</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">date</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">Format dd-mm-yyyy and future date</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">serv_desc</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">supply_from</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">date</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3">Format dd-mm-yyyy</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">supply_to</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">date</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">Format dd-mm-yyyy and future date</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">qty</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">int</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">serv_code</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-indigo-600">Mandatory / Optional</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">Mandatory for refill, optional for lab</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">prov_name</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">prov_frequent_city</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">service_type</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-blue-700 tw-font-medium">Mandatory</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-700">Possible value refill / lab</td>
                                        </tr>
                                        <tr className="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">chronic_conditions_of_mem</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">string</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3"></td>
                                        </tr>
                                        <tr className="hover:tw-bg-gray-50">
                                            <td className="tw-px-4 tw-py-3 tw-font-medium">generated_date</td>
                                            <td className="tw-px-4 tw-py-3 tw-text-gray-600">date</td>
                                            <td className="tw-px-4 tw-py-3">Optional</td>
                                            <td className="tw-px-4 tw-py-3">Format dd-mm-yyyy</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div className="tw-mt-6 tw-flex tw-justify-center">
                                <Button 
                                    variant="primary"
                                    className="btn save-btn"
                                    onClick={() => setShowBulkUploadGuidelinesModal(false)}
                                >
                                    Close Guidelines
                                </Button>
                            </div>
                        </Modal.Body>
                    </div>
                </Modal>
            </section>
        </>
    )
}

export default DataUploadHistory